// import React from 'react'
// import CIcon from '@coreui/icons-react'

const _nav = [
  {
    _tag: 'CSidebarNavItem',
    name: 'Facturas',
    to: '/facturas',
    icon: 'cil-asterisk',
  },
  {
    _tag: 'CSidebarNavItem',
    name: 'Modelo 347',
    to: '/otros-documentos',
    icon: 'cil-asterisk',
  },
]

export default _nav
